import { EJ2Instance, RecurrenceEditorChangeEventArgs } from '@syncfusion/ej2-schedule'
import { DropDownList } from '@syncfusion/ej2-dropdowns'
import { NumericTextBox } from '@syncfusion/ej2-inputs'

// From https://www.syncfusion.com/forums/148533/customizing-recurrence-editor
export function disallowInfiniteRecurrenceInDropdown(
  recurrenceArgs: RecurrenceEditorChangeEventArgs,
  previousType: string,
) {
  if (recurrenceArgs.value) {
    const repeatType: string = recurrenceArgs.value.split('=')[1].split('')[0]
    const end = (document.querySelector('.e-end-on-element') as EJ2Instance).ej2_instances[0] as DropDownList
    const interval = (document.querySelector('.e-repeat-interval.e-numerictextbox') as EJ2Instance)
      .ej2_instances[0] as NumericTextBox

    if (end.getItems()[0].getAttribute('data-value') === 'never') {
      ;(end.getItems()[0] as HTMLElement).style.display = 'none'
      end.index = end.index ? end.index : 1
    }

    if (previousType !== repeatType) {
      ;(end.getItems()[0] as HTMLElement).style.display = 'none'
      end.index = 1
    }
    return repeatType
  }

  return previousType
}
